export const MediaFileType = {
    Image: 0,
    Pdf: 1,
    Other: 2
}